import { render, staticRenderFns } from "./TabelaMateriaisTransferencia.vue?vue&type=template&id=d853403e&scoped=true&"
import script from "./TabelaMateriaisTransferencia.vue?vue&type=script&lang=js&"
export * from "./TabelaMateriaisTransferencia.vue?vue&type=script&lang=js&"
import style0 from "./TabelaMateriaisTransferencia.vue?vue&type=style&index=0&id=d853403e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d853403e",
  null
  
)

export default component.exports